// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"0073d9ae","90":"fed034fc"}[chunkId] + ".chunk.js";
};